exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".serviceMechanicOrdersComponent .clickable[data-v-19f115de]{cursor:pointer}\n", ""]);

